<template>
    <div>
        <!-- <div
        class="
            animate__animated animate__fadeIn animate__delay-2s
        "
        :class="[ type !== '' ? 'w-footer-block-inner' : 'w-footer-block' ]"
        >
            <div class="w-footer-logo">
                <img src="../../assets/images/privacy-tip.png" style="width: 54px;" @click="privacyModal" />
            </div>
        </div> -->

        <!-- start of screenshot modal -->
        <b-modal id="privacy-modal" dialog-class="admin-portal-modal" header-class="admin-portal-bg secondary px-3 py-2" hide-footer hide-header size="xl" ref="privacyModal" @hide="onHide">
            <div class="d-flex privacy-holder" @click="hidePrivacyModal">
                <h2>A2P Messaging Privacy Policy</h2>
                <h2>Effective Date: 07/01/2025</h2>
                <p>At GameLab, we value your privacy and are committed to protecting your personal information. This policy describes how we handle data used solely for Application-to-Person (A2P) messaging related to two-factor authentication (2FA).</p>
                <h4>1. Purpose of A2P Messaging</h4>
                <p>We use A2P messaging only to deliver verification codes for two-factor authentication. This enhances the security of your account by confirming your identity during login or other sensitive actions.</p>
                <h4>2. What Information We Collect</h4>
                <p>To send you 2FA codes, we collect and securely store:<br>
                Your phone number or email address (whichever you provide for 2FA)<br>
                Timestamps of verification requests</p>
                <h4>3. How We Use Your Information</h4>
                <p>We use your contact information exclusively to:<br>
                Send one-time verification codes to your phone or email<br>
                Confirm your identity when logging in or performing secure actions<br>
                We do not use this information for marketing, analytics, or any other purpose.</p>
                <h4>4. Data Sharing</h4>
                <p>We do not sell your information. Your data may be processed by trusted third-party providers (e.g., SMS gateways or email services) solely for the purpose of delivering 2FA messages.</p>
                <h4>5. Data Retention</h4>
                <p>We retain only the minimum data required to support secure authentication and comply with legal requirements. Verification codes and related metadata are stored temporarily and securely.</p>
                <h4>6. Your Privacy Choices</h4>
                <p>You may disable two-factor authentication at any time via your account settings. However, doing so may reduce the security of your account.</p>
                <h4>7. Contact Us</h4>
                <p>If you have questions or concerns about this policy, contact us at:<br>
                privacy@gladis.app</p>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "AdminPrivacyFooter-view",
    data() {
        return {
        };
    },
    props: ['type'],
    mounted() {
    },
    methods: {
        privacyModal() {
            this.$bvModal.show('privacy-modal');
        },
        hidePrivacyModal() {
            const modalEl = document.getElementById("privacy-modal");
            if (modalEl) {
                console.log("HERE IS MODAL : ", modalEl);
                modalEl.style.transition = "opacity 0.2s ease";
                modalEl.style.opacity = "0";
            }
            setTimeout(() => {
                this.$bvModal.hide('privacy-modal');
            }, 300);
        },
        onHide(bvEvent) {
            // Detect backdrop click
            if (bvEvent.trigger === 'backdrop') {
                bvEvent.preventDefault();
                this.hidePrivacyModal();
            }
        },
    }
}
</script>
<style scoped>
:deep(.modal.show .modal-dialog) {
    max-width: calc(100vw - 60px);
    width: calc(100vw - 60px);
    height: calc(100vh - 50px);
    max-height: calc(100vh - 50px);
}
:deep(.modal.show .modal-dialog .modal-content) {
    height: calc(100vh - 50px);
    max-height: calc(100vh - 50px);
}
:deep(#privacy-modal) {
    overflow: hidden;
}
:deep(.modal.show .modal-dialog .modal-content .modal-body) {
    background: #000;
    color: #dfdfdf;
    height: 100%;
}
.privacy-holder {
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    overflow-y: auto;
    scrollbar-width: none;
}
.privacy-holder::-webkit-scrollbar {
    display: none;
}
.privacy-holder h2 {
    font-size: 1.60rem;
}
.privacy-holder h4 {
    font-size: 1.25rem;
}
.privacy-holder p {
    font-size: 0.95rem;
}
@media screen and (max-width: 425px) {
    :deep(.modal.show .modal-dialog) {
        max-width: unset;
        width: auto;
    }
}
.w-footer-block {
    width: 100%;
    justify-content: center;
}
</style>